import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/app.css';
import '../css/index.css';
import '../css/disenoGlobal.css';

class Footer extends React.Component{
  render(){
    return(
    <div id="globalContent" class="container-fluid">
      <div class="row">
        <footer class="footer bg-primary text-white col-12 col-sm-12">
          <hr width="80%" height="1px" style={{ zIndex: '5', border: 'white solid 1px', marginBottom: '0px'}} />
          <div class="row text-center">  
            <div class="col-10 col-sm-10 offset-1 offset-sm-1">
              <div class="hidden-lg-up text-white text-center" style={{fontSize: '15px'}}>
                <li class="list-inline-item col-12 col-sm-3 offset-sm-1" style={{float: 'left'}}>
                  <a href="https://www.antp.org.mx/aviso-de-privacidad" class="text-white">
                    <p style={{lineHeight: '20px', marginTop: '5%'}}>
                    Aviso de Privacidad
                    </p>
                  </a>
                </li>
                <li class="list-inline-item col-12 col-sm-3" style={{float: 'left'}}>
                  <a href="https://www.antp.org.mx/mapa-de-sitio" class="text-white">
                    <p style={{lineHeight:'20px', marginTop: '5%'}}>
                      Mapa del Sitio
                    </p>
                  </a>
                </li>
                <li class="list-inline-item col-12 col-sm-3" style={{float: 'left', paddingBottom: '20px'}}>
                  <a href="https://www.antp.org.mx/prensa" class="text-white">
                    <p style={{lineHeight: '20px', marginTop:'5%'}}>
                      Recursos Prensa
                    </p>
                  </a>
                </li>
              </div>
              <div class="hidden-md-down text-white text-center">
                <li class="list-inline-item col-lg-4" style={{float: 'left', padding: '0px', margin: '0px'}}>
                  <a href="https://www.antp.org.mx/aviso-de-privacidad" class="text-white" style={{padding: '0px'}}>
                    Aviso de Privacidad
                  </a>
                </li>
                <li class="list-inline-item col-lg-4" style={{float: 'left', padding: '0px', margin: '0px'}}>
                  <a href="https://www.antp.org.mx/mapa-de-sitio" class="text-white" style={{padding: '0px'}}>
                    Mapa del Sitio
                  </a>
                </li>
                <li class="list-inline-item col-lg-4" style={{float: 'left', padding: '0px', margin: '0px'}}>
                  <a href="https://www.antp.org.mx/prensa" class="text-white" style={{padding: '0px', margin: '0px'}}>
                    <span style={{padding: '0px ', margin: '0px'}}>
                      Recursos Prensa
                    </span>
                  </a>
                </li>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
      );
    }
  }
  
  export default Footer;